'use strict';

const closeIcon = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="7" cy="7.125" r="6.5" fill="#D8D8D8"/>
  <path d="M9.97552 5.03921L7.8996 7.11513L9.97552 9.21081C10.2325 9.44808 10.2325 9.86321 9.97552 10.1005C9.73827 10.3575 9.32309 10.3575 9.08584 10.1005L7.00992 8.02458L4.91423 10.1005C4.67698 10.3575 4.2618 10.3575 4.02455 10.1005C3.76753 9.86321 3.76753 9.44808 4.02455 9.21081L6.10047 7.11513L4.02455 5.03921C3.76753 4.80195 3.76753 4.38678 4.02455 4.14952C4.2618 3.89251 4.67698 3.89251 4.91423 4.14952L7.00992 6.22544L9.08584 4.14952C9.32309 3.89251 9.73827 3.89251 9.97552 4.14952C10.2325 4.38678 10.2325 4.80195 9.97552 5.03921Z" fill="#353535"/>
</svg>`

import emailMisspelled, { all } from 'email-misspelled';
import sbfTopEmails from './sbf_top_email_domains.json';
const emailChecker = emailMisspelled({ maxMisspelled: 3, domains: [...new Set([...sbfTopEmails, ...all])] });

export default function initEmailFields (selector = '.inline-input input[type="email"]') {
    const $emailFields = $(selector).not('.esinit').addClass('esinit');

    const $picker = $('<div class="email-checker" />');
    const $label = $('<span class="email-checker__label" />');
    const $label_result = $('<a href="#" class="email-checker__result" />');
    const $close = $('<a href="#" class="email-checker__close" />').append(closeIcon);

    $label.append('Did you mean ').append($label_result).append('?');
    $picker.append($label).append($close);

    const emailPattern = /^(?:[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+([.][a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]*)+|["](?:[^\\x01-\\x08\\x11\\x12\\x14-\\x1f\\x7f\\x0d\\x22\\x5c]|(\\x5c[\\x01-\\x09\\x11\\x12\\x14-\\x7f]))+["]|(?:[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+|["](?:[^\\x01-\\x08\\x11\\x12\\x14-\\x1f\\x7f\\x0d\\x22\\x5c]|(\\x5c[\\x01-\\x09\\x11\\x12\\x14-\\x7f]))+["])([.](?:[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+|["](?:[^\\x01-\\x08\\x11\\x12\\x14-\\x1f\\x7f\\x0d\\x22\\x5c]|(\\x5c[\\x01-\\x09\\x11\\x12\\x14-\\x7f]))+["]))*)@(?:([A-Za-z0-9-]{1,63}[.])+[A-Za-z]{2,})$/;

    let $activeEmailField = [];
    let closedSuggestion;
    const onBlur = () => {
        setTimeout(() => {
            const stillActive = [$activeEmailField[0], $label_result[0], $close[0]].includes(document.activeElement)
            if (! stillActive) $picker.remove();
        }, 0);
    };

    $emailFields.on('blur', onBlur);
    $emailFields.on('input focus', function (ev) {
        const $el = $(this);
        const $parent = $el.parent();
        $activeEmailField = $el;

        window.clearTimeout(initEmailFields.emailSpellCheckWarn);
        const email = $el.val();

        // hide the $picker and return if we don't yet have a valid email or if we have no suggestions
        if (!emailPattern.test(email)) {
            $picker.remove();
            return;
        }
        const results = emailChecker(email);
        if (results.length === 0) {
            $picker.remove();
            return;
        }

        const suggestion = results.at(0).corrected
        if (suggestion === closedSuggestion) {
            // the user closed this suggestion so don't show it again
            return;
        }
        const handler = () => {
            $parent.append($picker);
            $label_result.text(suggestion);
            $close.off('click').on('click', () => {
                $picker.remove();
                closedSuggestion = suggestion;
                $el.focus();
                return false;
            });

            $label_result.off('click').on('click', () => {
                $el.val(suggestion);
                $picker.remove();
                return false;
            });

            const $links = $close.add($label_result);
            $links.off('blur').on('blur', onBlur);

            // if tabindexes are used we need to copy the tabindex of the input so we tab to the result and close next
            const tabIndex = $el.attr('tabindex');
            if (tabIndex) {
                $links.attr('tabindex', tabIndex);
            } else {
                $links.removeAttr('tabindex');
            }
        };
        if (ev.type === 'focus') {
            handler();
        } else {
            initEmailFields.emailSpellCheckWarn = window.setTimeout(handler, 1000);
        }
    });
}
